const BASE = process.env.REACT_APP_API_URL || 'https://microled.com.ar/api';
const KEY  = process.env.REACT_APP_API_KEY  || 'ml-api-2024';

function getSessionToken() {
  try { return JSON.parse(localStorage.getItem('ml_admin_session')).token || ''; }
  catch { return ''; }
}

async function req(method, path, body) {
  const token = getSessionToken();
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': KEY,
      ...(token ? { 'x-session-token': token } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) throw new Error(`API ${method} ${path} → ${res.status}`);
  return res.json();
}

// ── Leads ─────────────────────────────────────────────────────────────────────
export const leadsAPI = {
  getAll:  ()           => req('GET',    '/leads'),
  create:  (lead)       => req('POST',   '/leads', lead),
  update:  (id, fields) => req('PUT',    `/leads/${id}`, fields),
  remove:  (id)         => req('DELETE', `/leads/${id}`),
};

// ── Categorías / Productos ────────────────────────────────────────────────────
export const categoriasAPI = {
  getAll:  ()     => req('GET',  '/categorias'),
  save:    (cats) => req('POST', '/categorias', cats), // array completo o una sola
};

// ── Galería Home ──────────────────────────────────────────────────────────────
export const galleryAPI = {
  getAll: ()      => req('GET',  '/gallery'),
  save:   (items) => req('POST', '/gallery', items),
};

// ── Categorías del home (Nuestros productos) ──────────────────────────────────
export const homeCatsAPI = {
  getAll: ()      => req('GET',  '/home-categories'),
  save:   (items) => req('POST', '/home-categories', items),
};

// ── Upload de imágenes al servidor ────────────────────────────────────────────
export function uploadImage(file) {
  const token = getSessionToken();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async () => {
      try {
        const base64 = reader.result.split(',')[1];
        const res = await fetch(`${BASE}/upload`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': KEY,
            ...(token ? { 'x-session-token': token } : {}),
          },
          body: JSON.stringify({ filename: file.name, mimeType: file.type, data: base64 }),
        });
        const json = await res.json();
        resolve(json);
      } catch (e) { reject(e); }
    };
    reader.onerror = () => reject(new Error('Error leyendo archivo'));
    reader.readAsDataURL(file);
  });
}

// ── Health ────────────────────────────────────────────────────────────────────
export const health = () => req('GET', '/health');
